import planningRecordService from './planningRecordService'

export default planningRecordService
